/**
 * Archivo: InicioSesion.js
 * Autor: Acher Egido Mairal
 * Fecha de última modificación: 2024-07-10
 * 
 * Descripción:
 * Este componente define la vista para el inicio de sesión de los usuarios. Proporciona campos para el correo electrónico
 * y la contraseña, y permite la visualización y ocultación de la contraseña. También maneja la lógica para la autenticación
 * de usuarios y la redirección en caso de inicio de sesión exitoso.
 * 
 * Dependencias:
 * - react: ^18.2.0
 * - react-router-dom: ^6.0.0
 * - Servicios/AutorizacionServicios: Funciones para interactuar con el servicio de autorización.
 * - Componentes/MetaTags: Componente para las etiquetas meta del documento.
 * 
 * Propósito:
 * Proveer una interfaz de usuario para el inicio de sesión, incluyendo la gestión de autenticación y redirección 
 * en caso de éxito, así como la visualización de mensajes de error y éxito.
 */

import { default as React, useState} from 'react';
import { useNavigate } from 'react-router-dom';
import '../Estilos/estilos.css'; 

import {iniciarSesion} from '../Servicios/AutorizacionServicios';

import logoUnizar from '../Imagenes/Iconos/LogoUZColor.png'
import verContraseña from '../Imagenes/Iconos/VerContraseña.png'
import noVerContraseña from '../Imagenes/Iconos/NoVerContraseña.png'
import MetaTags from '../Componentes/MetaTags';

function InicioSesion() {

    const navigate = useNavigate();

    const [correo, setCorreo] = useState('');
    const [contraseña, setContraseña] = useState('');
    const [mostrarContraseña, setMostrarContraseña] = useState(false)

    const [mensajeError, setMensajeError] = useState('');
    const [mensajeExito, setMensajeExito] = useState('');

    const irRegistroSesion = async (event) => {
        navigate(process.env.PUBLIC_URL+ '/RegistroSesion');
    };

    const irOrlaColegial = async (event) => {
        navigate(process.env.PUBLIC_URL+ '/OrlaColegial');
    };

    const toggleMostrarContraseña = () => {
        setMostrarContraseña(!mostrarContraseña);
    };

    //Función para iniciar sesión (llama a un servicio)
    const handleIniciarSesion = async (e) => {
        e.preventDefault();
        const resultado = await iniciarSesion(correo, contraseña);
        //console.log("resultado: ", resultado)
        if (resultado && resultado.success) {
            setMensajeError('');
            setMensajeExito('Inicio de sesión exitoso');
            irOrlaColegial()
        } else {
            setMensajeError( resultado ?resultado.message : 'Error desconocido');
            setMensajeExito('');
        }
    }

    return (
        <>
        <MetaTags />
        <div className="container-fluid " style={{height:'100vh', backgroundColor: '#E6E7E8', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
            <div className='container-fluid col-xl-8 col-lg-8 col-md-8 col-sm-9 col-10 justify-content-center d-flex' style={{marginTop: '-5rem'}}>
                <div className='container-fluid'>
                    <div className='row-fluid col-12 d-flex justify-content-center'>
                        <img
                            alt="logoUnizar"
                            className="img mt-1"
                            src= {logoUnizar}
                            style={{height: '5rem', width: '14rem'}}
                        />
                    </div>
                    <div className='container-fluid col-12 ' style={{ backgroundColor:'white', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)', 
                        borderLeft: '1px solid rgba(0, 0, 0, 0.1)',
                        borderRight: '1px solid rgba(0, 0, 0, 0.1)',
                        borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                        borderTop: 'none',
                         boxShadow: '0 8px 8px rgba(0, 0, 0, 0.2)'}}>
                        <div className='p-3 text-center'>
                            <span className='text-black customFontSizeTextoPequeño '>Inicio de sesión</span>
                        </div>
                        <form onSubmit={handleIniciarSesion}>
                            <div className="form-group text-start">
                                <div className='row-fluid p-1'>
                                    <span className='text-black customFontSizeTextoPequeño'>Usuario/a </span>
                                </div>
                                <input
                                    type="email"
                                    className="form-control col-11"
                                    placeholder="Usuario/a"
                                    value={correo}
                                    onChange={(e) => setCorreo(e.target.value)}
                                />
                            </div>
                            <div className="form-group">
                                <div className='row-fluid p-1'>
                                    <span className='text-black customFontSizeTextoPequeño'>Contraseña </span>
                                </div>
                                <div className='row-fluid justify-content-between d-flex'> 
                                    <input
                                        type={mostrarContraseña? "text" : "password"}
                                        className="form-control col-11"
                                        placeholder="Contraseña"
                                        value={contraseña}
                                        onChange={(e) => setContraseña(e.target.value)}
                                    />
                                    <img
                                        src={mostrarContraseña ? verContraseña : noVerContraseña}
                                        style={{height:'2rem', width:'2rem', cursor:'pointer'}}
                                        alt={mostrarContraseña ? "Mostrar contraseña" : "Ocultar contraseña"}
                                        onClick={toggleMostrarContraseña}
                                    />
                                </div>
                            </div>
                            <div className='row-fluid d-flex justify-content-between pb-2 '>
                                <span className='customFontSizeTextoPequeño ' style={{color: '#213C70', cursor:'pointer'}} onClick={irRegistroSesion}>Registrarse </span>
                                <button type="submit" className='text-white' style={{backgroundColor:'#213C70', cursor: 'pointer'}}>
                                    Entrar
                                </button>
                            </div>
                        </form>
                        {mensajeError && <div className="alert alert-danger mt-3" role="alert">{mensajeError}</div>}
                        {mensajeExito && <div className="alert alert-success mt-3" role="alert">{mensajeExito}</div>}
                    </div>
                </div>
            </div>
        </div>
        </>
    );
};

export default InicioSesion;